import 'dayjs/locale/it';
import { ImageList, ImageListItem } from '@mui/material';
import { motion } from 'motion/react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { useMediaQueries, useStrapiImageFormat } from '@hooks';
import { useRouter } from 'next/router';
import dayjs from 'dayjs';
import LazyImage from 'components/LazyImage/LazyImage';
import React, { useRef } from 'react';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);
const MasonryList = ({
  gallery,
  showCaption = true,
  pagination = false,
}) => {
  const { locale } = useRouter();
  const { isMobile } = useMediaQueries();
  const sliderRef = useRef(null);
  // Set Day.js locale dynamically
  dayjs.locale(locale);

  return (
    <>
      {isMobile ? (
        <>
          <Splide
            tag="section"
            ref={sliderRef}
            options={{
              drag: true,
              type: 'slide',
              width: '100%',
              height: '100%',
              autoplay: true,
              pagination: pagination,
              arrows: false,
              padding: 0,
              rewind: true,
              snap: true,
              perPage: 1,
              perMove: 1,
              focus: 0,
              flickPower: 800,
              flickMaxPages: 1,
              lazyLoad: 'nearby',
              video: {
                loop: true,
                mute: true,
              },
            }}
          >
            {gallery?.length > 0 &&
              gallery.map(({ attributes }, i) => {
                return (
                  <SplideSlide
                    key={i}
                    onClick={(e) => e.preventDefault()}
                    className="h-full"
                  >
                    {/* Wrapper div for hover effect */}
                    <div className="relative h-full w-full">
                      <LazyImage
                        img={useStrapiImageFormat({
                          img: attributes,
                        })}
                        className=" relative w-screen h-[40vh] object-cover transition-opacity duration-300 group-hover:opacity-50"
                      />
                      {attributes?.caption && showCaption && (
                        <div className="bg-primary p-4 text-white w-full">
                          <p>{attributes?.caption}</p>
                        </div>
                      )}
                    </div>
                  </SplideSlide>
                );
              })}
          </Splide>
        </>
      ) : (
        <ImageList variant="masonry" cols={3} gap={16}>
          {gallery?.length > 0 &&
            gallery.map(({ attributes }, i) => {
              return (
                <ImageListItem key={i} className="group relative">
                  {/* Wrapper div for hover effect */}
                  <motion.div
                    className="relative"
                    initial={{
                      opacity: 0,
                      scale: 0.9,
                    }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{
                      duration: 0.7,
                      ease: 'easeOut',
                      delay: i * 0.1,
                    }}
                    viewport={{ once: true, amount: 0.1 }}
                  >
                    <LazyImage
                      img={useStrapiImageFormat({
                        img: attributes,
                      })}
                      className="max-h-[600px] relative w-full object-cover transition-opacity duration-300 group-hover:opacity-50"
                    />
                    {showCaption && attributes?.caption && (
                      <div className="absolute inset-0 flex  items-center justify-center bg-primary bg-opacity-[0.8] text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="text-center capitalize body space-y-3">
                          <div>{attributes?.caption}</div>
                        </div>
                      </div>
                    )}
                    {/* Text overlay */}
                  </motion.div>
                </ImageListItem>
              );
            })}
        </ImageList>
      )}
    </>
  );
};

export default MasonryList;
